import React, { FC, useState } from "react";
import { YHModal } from "@/components/YHModal";
import { usePurchasePoDetailsModel } from "./purchasePoDetailsModel";
import { YhBox } from "@/components/YhBox";
import { Table, Select, message } from "antd";
import { ColumnsType } from "antd/lib/table";
import { IPurchasePoDetail } from "../../purchasePoType";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { ISelectOptions } from "@/types/ScmTypes";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import { RouterParamType } from "@/model/navModel";

export const AddTempShelfModal: FC<RouterParamType> = ({ id, mode }) => {

	const {
		addTempShelfModal: visible,
		setAddTempShelfModal,
		detailDataSource,
		detailEditForm,
		warehouseData,
		detailAddList,
		detailAddForm,
		setDetailDataSource, setDetailAddList,
		detailLookForm
	} = usePurchasePoDetailsModel();
	let dataList = mode === 'add' ? detailAddList : detailDataSource
	const detailForm = mode === "add" ? detailAddForm : mode === "edit" ? detailEditForm : detailLookForm;
	const { warehouseList, shopAndOrg: { shopId, shopName }, setLoadingInfo } = useGlobalModel()

	const [shelfInfo, setShelfInfo] = useState<IVRMshelfDetail | null>(null);  //记录选中的货位信息

	const onCancel = () => {
		setAddTempShelfModal(false);
		setShelfInfo(null);
	};

	//货位列表 Api
	const shelfLoadData = async (whObj: ISelectOptions) => {
		const searchParams = {
			shopId,
			warehouseId: whObj.id,
			warehouseCode: whObj.value,
			code: "临时货位",
			pageSize: 10,
			pageNum: 1,
		}

		let { retData } = await warehouseService.shelfPage(searchParams);
		const { records, ...pg } = retData;
		if (!records || !records.length) {
			message.warning("该仓库下没有临时货位，请联系后台人员添加");
			setShelfInfo(null);
			return;
		}
		let newData: any = records.find((item) => item.code == '临时货位')
		setShelfInfo(newData);
	}

	const onSubmit = () => {
		if (!shelfInfo) {
			message.warning("请选择仓库或者该仓库没有临时货位");
			return;
		}
		let setData = mode === "edit" ? setDetailDataSource : setDetailAddList
		setData(origin => origin.map(item => {
			if (!item.shelfCode) {
				return {
					...item,
					shelfId: shelfInfo.id,   //货位Id
					shelfCode: shelfInfo.code,   //货位编码
					warehouseName: shelfInfo.warehouseName,   //仓库名称
					warehouseCode: shelfInfo.warehouseCode,  //仓库编码
					isShelfCode: true
				}
			};
			return item;
		}));
		onCancel();
	}

	const columns: ColumnsType<IPurchasePoDetail> = [
		{
			title: '序号',
			fixed: "left",
			width: 40,
			align: "center",
			render: (t: any, r: any, i: number) => i + 1
		}, {
			title: '商品编号',
			align: "center",
			dataIndex: 'materialCode',
		}, {
			title: '商品名称',
			align: "center",
			dataIndex: 'materialName',
		}
	];

	const rightChildren = <div>
		<span className="label-name">仓库：</span>
		<Select
			style={{ width: 260 }}
			options={transOptions(warehouseData[mode].map((item: any) => {
				return { ...item, enable: (detailForm.purchaseTypeCode == 'purchase-type.c' && item.name == '直发库') ? 1 : (detailForm.purchaseTypeCode !== 'purchase-type.c' && item.name !== '直发库') ? 1 : 0 }
			}
			))}  //过滤掉直发库
			placeholder="请选择仓库"
			onChange={(value: string, option) => {
				value && shelfLoadData(option as ISelectOptions)
			}}
		/>
	</div>



	return <YHModal
		visible={visible}
		onOk={onSubmit}
		onCancel={onCancel}
		title="添加临时货位"
		width={'70%'}
		bodyHeight={400}
		showFooter={true}
	>
		<YhBox title={rightChildren} style={{ marginBottom: "15px" }}>
			<Table
				bordered
				columns={columns}
				dataSource={dataList.filter(item => !!!item.shelfCode)}
				pagination={false}
				scroll={{ x: 'max-content', }}
			/>
		</YhBox>
	</YHModal>
}